import { render } from "./UpdateSpecialPaymentRequestReimb.vue?vue&type=template&id=a8f742c0&scoped=true"
import script from "./UpdateSpecialPaymentRequestReimb.vue?vue&type=script&lang=ts"
export * from "./UpdateSpecialPaymentRequestReimb.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-a8f742c0"

export default script